import React, { useState } from 'react';

import './ClipboardCopy.scss';

import { Icon, icons } from '@hoffmann/pattern-library-2';

interface ClipboardCopyProps {
  value: string;
}

const ClipboardCopy = (props: ClipboardCopyProps) => {
  const [isClicked, setClicked] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(props.value);

    if (!isClicked) {
      setTimeout(() => setClicked(false), 3000);
      setClicked(true);
    }
  };

  return (
    <div data-cy="icon" className="clipboard-copy" onClick={copyToClipboard}>
      <Icon
        source={isClicked ? icons.Check : icons.FileCopy}
        classNames={
          isClicked
            ? ['clipboard-copy__icon', 'clipboard-copy__icon--green']
            : ['clipboard-copy__icon']
        }
      />
    </div>
  );
};

export default ClipboardCopy;
